export default "__VITE_ASSET__05fbb258__"